export default __webpack_public_path__ + "static/media/sticker_mask_original.0939fe44.jpg";